<template>
  <v-card class="rounded-lg white">
    <v-card-title class="secondary--text mb-5">
      <v-img src="/img/icons/bell.svg" max-width="20" max-height="20" class="ml-3"></v-img>
      {{ title }}
      <v-spacer></v-spacer>
    </v-card-title>
    <v-card-text>
      <m-datatable
        :headers="headers"
        :apiUrl="url"
        :filters.sync="filters"
        ref="datatable"
        export-url="reports/lists/userNotification"
        @click:row="openDetailDialog"
        :item-class="getItemClass"
      ></m-datatable>
    </v-card-text>

    <notification-dialog
      :item="item"
      :detailDialog.sync="detailDialog"
      @statusChanged="$refs.datatable.getDataFromApi()"
    />
  </v-card>
</template>

<script>
import NotificationDialog from "./NotificationDialog.vue";
export default {
  name: "Notifications",
  components: { NotificationDialog },
  data() {
    return {
      filters: {},
      detailDialog: false,
      item: null,
    };
  },
  computed: {
    title() {
      return this.setDocumentTitle("اعلان های دریافتی");
    },
    url() {
      return "users/notifications";
    },
    headers() {
      let headers = [
        {
          text: "عنوان",
          value: "notification.title",
        },
        {
          text: "توضیحات",
          value: "notification.explanation",
        },
        {
          text: "تاریخ و ساعت",
          value: "created_at",
          type: "date",
        },
        {
          text: "فرستنده",
          value: "created_by",
        },
        {
          text: "در کسب و کار",
          value: "notification.forwarder_company.name",
        },
        {
          text: "تاریخ و ساعت",
          value: "created_at",
          type: "date",
        },
        {
          text: "وضعیت",
          value: "status",
        },
      ];

      return headers;
    },
  },
  methods: {
    openDetailDialog(item) {
      this.item = item;
      this.detailDialog = true;
    },
    getItemClass(item) {
      if (item.status_codename == "ur") return "grey lighten-3 clickable";
      return "white clickable";
    },
  },
};
</script>

<style lang="scss">
.clickable {
  cursor: pointer;
}
</style>